var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var DocumentService = /** @class */ (function (_super) {
            __extends(DocumentService, _super);
            function DocumentService(injectedBreeze, $q, $http, systemLevelService) {
                var _this = _super.call(this, injectedBreeze, $q) || this;
                _this.$http = $http;
                _this.systemLevelService = systemLevelService;
                return _this;
            }
            DocumentService.prototype.getDocumentConfiguration = function (id) {
                var query = this.breezeModule.EntityQuery
                    .from("DocumentConfigurations")
                    .where("id", "==", id)
                    .expand("canDownloadSecureDocumentSecurityMatrix, canSecureDocumentSecurityMatrix, myAvailableDocumentTypes.mySystemCode");
                return this.fetch(query);
            };
            DocumentService.prototype.getDocumentConfigs = function (processConfigId) {
                var query = this.breezeModule.EntityQuery
                    .from("DocumentConfigurations")
                    .where("processConfiguration_id", "==", processConfigId)
                    .expand("canDownloadSecureDocumentSecurityMatrix, canSecureDocumentSecurityMatrix, myAvailableDocumentTypes.mySystemCode");
                return this.executeQuery(query);
            };
            DocumentService.prototype.createDocumentConfig = function () {
                var docConfig = this.createNewEntity("DocumentConfiguration");
                docConfig.uniqueIdentifier = services.UtilityService.generateGuidComb();
                docConfig.overrideSystemDocumentAccepts = false;
                docConfig.includeDocumentType = false;
                docConfig.includeDocumentComment = false;
                docConfig.includeDocumentDelete = false;
                docConfig.maxDocumentsAllowed = 1;
                docConfig.useSingleMetadataForMultipleFiles = false;
                return docConfig;
            };
            DocumentService.prototype.createAvailableDocumentType = function (docConfig, systemCode) {
                var documentTypeAvailability = this.createNewEntity("DocumentTypeAvailability");
                documentTypeAvailability.myDocumentConfiguration = docConfig;
                documentTypeAvailability.documentConfiguration_id = docConfig.id;
                documentTypeAvailability.mySystemCode = systemCode;
                documentTypeAvailability.systemCode_id = systemCode.id;
                documentTypeAvailability.isAvailable = false;
                return documentTypeAvailability;
            };
            DocumentService.prototype.getFaClass = function (fileName) {
                if (!fileName)
                    return 'fa-file-o';
                var imageExtensions = ['.jpg', '.jpeg', '.jfif', '.exif', '.tiff', '.tif', '.gif', '.bmp', '.png'];
                var wordExtensioins = ['.doc', '.dot', '.docx', '.docm', '.dotx', '.dotm', '.docb'];
                var excelExtensions = ['.xls', '.xlt', '.xlm', '.xlsx', '.xlsm', '.xltx', '.xltm'];
                var archiveExtensions = ['.zip', '.tar', '.7z'];
                var textExtensions = ['.txt'];
                var lowerCaseFileName = fileName.toLowerCase();
                if (lowerCaseFileName.endsWith(".pdf"))
                    return 'fa-file-pdf-o';
                var image = Enumerable.from(imageExtensions).any(function (i) { return lowerCaseFileName.endsWith(i); });
                if (image)
                    return 'fa-file-image-o';
                var wordDoc = Enumerable.from(wordExtensioins).any(function (i) { return lowerCaseFileName.endsWith(i); });
                if (wordDoc)
                    return 'fa-file-word-o';
                var excel = Enumerable.from(excelExtensions).any(function (i) { return lowerCaseFileName.endsWith(i); });
                if (excel)
                    return 'fa-file-excel-o';
                var archive = Enumerable.from(archiveExtensions).any(function (i) { return lowerCaseFileName.endsWith(i); });
                if (archive)
                    return 'fa-file-archive-o';
                var text = Enumerable.from(textExtensions).any(function (i) { return lowerCaseFileName.endsWith(i); });
                if (text)
                    return 'fa-file-text-o';
                return 'fa-file-o';
            };
            DocumentService.prototype.getFileSizeStringFilter = function (filesize) {
                return this.getFileSizeString(parseInt(filesize));
            };
            DocumentService.prototype.getFileSizeString = function (filesize) {
                var kb = 1024;
                var mb = 1048576;
                if (!filesize)
                    return "unknown";
                if (filesize < kb)
                    return filesize + " bytes";
                if (filesize < mb)
                    return Math.floor(filesize / kb) + " KB";
                return Math.floor(filesize / mb) + " MB";
            };
            return DocumentService;
        }(services.DataService));
        services.DocumentService = DocumentService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService("DocumentService", ["breeze", "$q", "$http", "systemLevelService"]);
